import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { useParams } from "react-router";
import PropTypes from "prop-types";
import { INVITE_TYPE } from "../../../../../constants/InviteConstants";
import SendSMSAndWhatsApp from "../SendSMSAndWhatsApp";
import useLanguageChange from "../../../../../hooks/useLanguageChange";
import { REACT_APP_SITE_URL, TWILLIO_URL_ENDPOINT } from "../../../../../constants/Constants";
import { UK_COUNTRY_CODE_NEW, UK_COUNTRY_CODE_OLD } from "../../../../../constants/LanguageConstants";
import { getSessionId } from "../../../../../shared/utility";

const SmsTab = ({ handleSendInvite, isDoneBtnVisible, handleCloseModal, isSentBtnVisible, mobileNumberRef }) => {
    const { getCountryListData, privacyPolicyData } = useSelector((state) => state.onLoadData);
    const { joinMeetingSmsTemplate, selectedSmsCountry } = useSelector((state) => state.inviteParticipant);

    const localisedValues = useLanguageChange();
    const params = useParams();
    const sessionId = getSessionId(params?.sessionId);

    const [smsTemplate, setSmsTemplate] = useState("");

    useEffect(() => {
        if (isEmpty(getCountryListData) || isEmpty(privacyPolicyData)) return;

        let countryCode = selectedSmsCountry?.iso2 === UK_COUNTRY_CODE_OLD ? UK_COUNTRY_CODE_NEW : selectedSmsCountry?.iso2;
        const countryObj = getCountryListData.find((country) => country.countryCode.toLocaleLowerCase() === countryCode);

        let smsMsg = "";

        if (!privacyPolicyData?.twilioWhitelisted && countryObj?.isNordicCountry) {
            smsMsg = "Use this code to get started: " + REACT_APP_SITE_URL + TWILLIO_URL_ENDPOINT + sessionId;
        } else if (joinMeetingSmsTemplate) {
            smsMsg = joinMeetingSmsTemplate;
        } else {
            smsMsg = localisedValues.has_sent_you_link_for_video_conference;
            smsMsg = smsMsg?.replace("<company_name>", privacyPolicyData.domainName);
        }

        setSmsTemplate(smsMsg);
    }, [getCountryListData, privacyPolicyData, selectedSmsCountry]);

    return (
        <SendSMSAndWhatsApp
            type={INVITE_TYPE.SMS}
            id='invite-sms'
            testId='invite-sms-tab'
            defaultCountryCode={selectedSmsCountry.iso2}
            smsTemplate={smsTemplate}
            handleSendInvite={handleSendInvite}
            handleCloseModal={handleCloseModal}
            isSentBtnVisible={isSentBtnVisible}
            isDoneBtnVisible={isDoneBtnVisible}
            mobileNumberRef={mobileNumberRef}
            selectedCountry={selectedSmsCountry}
        />
    );
};

SmsTab.propTypes = {
    handleSendInvite: PropTypes.func,
    isDoneBtnVisible: PropTypes.bool,
    handleCloseModal: PropTypes.func,
    isSentBtnVisible: PropTypes.bool,
    mobileNumberRef: PropTypes.any,
};

export default SmsTab;
